import { render } from "./NewToolShell.vue?vue&type=template&id=2ae09a97&scoped=true"
import script from "./NewToolShell.vue?vue&type=script&lang=js"
export * from "./NewToolShell.vue?vue&type=script&lang=js"

import "./NewToolShell.vue?vue&type=style&index=0&id=2ae09a97&scoped=true&lang=css"

import exportComponent from "../../../../../../vue-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ae09a97"]])

export default __exports__